import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IconWarning from '../../assets/icon-warning.svg';
import { setErrorMessage } from '../../app/store/majesticSlice';
import usePageNavigation from '../../hooks/usePageNavigation';
import { setImageSide } from '../../app/store/ocrSlice';

function ErrorMessageOcrModal({ handleCloseModal = () => {} }) {
  const { errorOcr } = useSelector((state) => state.ocr);

  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const { nagivatePreviousPage } = usePageNavigation();

  const handleClose = () => {
    setShow(false);
    dispatch(setErrorMessage({}));
    handleCloseModal();

    if (errorOcr.action === 'INIT' /* errorOcr.status === 401 */) {
      nagivatePreviousPage('');
    }

    // Esto envia al componente front cuando regresa un errorCode 101
    if (errorOcr.action === 'FRONT') {
      nagivatePreviousPage('DocumentFront');
      // Limpia los datos de imageReverse
      dispatch(setImageSide({ imageSide: 'imageReverse' }));
    }
  };
  // const handleShow = () => setShow(true);

  useEffect(() => {
    if (errorOcr?.messageFormatted !== '') {
      setShow(true);
    }
  }, [errorOcr]);

  const showErrorByStatus = () => {
    // console.log(errorOcr)
    if (errorOcr.status === 400) {
      return (
        <p className="mt-3 mb-0 app-txt-granite-80-dark app-fs-15 app-lh-h4">
          {t('TXT_ERROR_CHECK_DATA_CORRECT')}
        </p>
      );
    }

    if (errorOcr.status === 500) {
      return (
        <p className="mt-3 app-fs-14 app-txt-granite-80-dark">
          <small>
            Error #S-500-
            {Date.now()}
          </small>
        </p>
      );
    }

    return '';
  };

  const showMessageByType = () => {
    if (Array.isArray(errorOcr.message)) {
      return (
        <ul className="app-fw-notosans-regular">
          {errorOcr.message.map((errorMessage, index) => (
            <li
              key={index}
              className="mb-0 app-txt-granite-80-dark app-fs-15 app-lh-h4"
            >
              {errorMessage}
            </li>
          ))}
        </ul>
      );
    }

    return (
      <p className="mb-0 app-txt-granite-80-dark text-center app-fs-15 app-lh-h4">
        {errorOcr.messageFormatted}
      </p>
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      centered
    >
      <Modal.Header className="pt-3 pb-0 border-0">
        <Modal.Title className="mx-auto text-center">
          <img src={IconWarning} alt="icon-warning" className="pb-3" />
          {!errorOcr.showCallAgency && <p className="mb-0 app-fw-notosans-bold">{t('TXT_TITLE_NOTICE')}</p>}
          {errorOcr.showCallAgency && <p className="mb-0 app-fw-notosans-bold">{t('TXT_ERROR_NOT_MATCH_GUEST_TYPE')}</p>}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-1">
        { showMessageByType() }

        { showErrorByStatus() }

        {errorOcr.showCallAgency && (
          <div className="mt-2">
            <p className="mb-0 app-txt-granite-80-dark text-center app-fs-15 app-lh-h4">
              {t('TXT_WARNING_CALL_AGENCY')}
            </p>
            <p className="mb-0 mt-1 fs-4 app-txt-granite-80-dark app-fw-notosans-bold text-center">
              1-888-477-7227
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 mx-auto">
        <Button
          variant=""
          onClick={handleClose}
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height px-4"
        >
          {t('TXT_BTN_ACCEPT')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorMessageOcrModal;
